import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de6e09203c6a52/components/sections/BranchSolutionsShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de6e09203c6a52/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8de6e09203c6a52/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de6e09203c6a52/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de6e09203c6a52/components/sections/UseCasesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de6e09203c6a52/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6e09203c6a52/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6e09203c6a52/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6e09203c6a52/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6e09203c6a52/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6e09203c6a52/app/[locale]/branches/shared-branch.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6e09203c6a52/node_modules/next/dist/client/link.js");
